import { useEffect } from 'react';
import { useFeatureFlagsContext } from '@/contexts/featureFlags/FeatureFlagsContext';
import i18n from '@/i18n';

const LANGUAGE_STORAGE_KEY = 'i18nextLng';

const LanguageFeatureGate = () => {
  const context = useFeatureFlagsContext();
  const multilingualEnabled = context?.flags.ENABLE_MULTILINGUAL ?? false;

  useEffect(() => {
    if (multilingualEnabled) {
      return;
    }

    if (i18n.resolvedLanguage !== 'en') {
      void i18n.changeLanguage('en');
    }

    if (typeof window !== 'undefined') {
      window.localStorage.setItem(LANGUAGE_STORAGE_KEY, 'en');
      document.documentElement.lang = 'en';
    }
  }, [multilingualEnabled]);

  return null;
};

export default LanguageFeatureGate;